@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .logoWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    background-color: var(--surface-inverse);
    overflow: hidden;
    @include border-radius-full;
  }
}
